module.exports = __webpack_public_path__ + "img/html-evolution-3.bab79122.webp";